import { CustomerTypes } from "@faire/help-center-utils/enums/CustomerType";
import { useCustomerType } from "@faire/help-center-utils/hooks/useCustomerType";
import { Chevron } from "@faire/web--source/slate/icons/foundation/Chevron";
import { Row } from "@faire/web--source/slate/Layout";
import { LoadingSkeleton } from "@faire/web--source/slate/LoadingSkeleton";
import { Spacer } from "@faire/web--source/slate/spacing";
import ClickOutside from "@faire/web--source/ui/ClickOutside";
import { useState } from "@faire/web--source/ui/hooks/useState";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";

import { SEOOptimizedHeading } from "./SEOOptimizedHeading";

import { Menu } from "./Menu";

export interface IHeaderPageTitleProps {
  menu?: boolean;
}

export const HeaderPageTitle: React.FC<IHeaderPageTitleProps> = ({ menu }) => {
  const { customerType } = useCustomerType();
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  const handleMenuOpen = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const renderTitle = () => {
    if (customerType === CustomerTypes.RETAILER) {
      return (
        <SEOOptimizedHeading variant="paragraphSansMedium">
          <StrictLocalMsg
            defaultMessage="Help Center for Retailers"
            description={{
              text: "This is the header for the help center retailer visitors",
            }}
          />
        </SEOOptimizedHeading>
      );
    }
    if (customerType === CustomerTypes.BRAND) {
      return (
        <SEOOptimizedHeading variant="paragraphSansMedium">
          <StrictLocalMsg
            defaultMessage="Help Center for Brands"
            description={{
              text: "This is the header for the help center brand visitors",
            }}
          />
        </SEOOptimizedHeading>
      );
    }
    return <LoadingSkeleton width="175px" height="20px" />;
  };

  return (
    <ClickOutside onClickOutside={() => setIsMenuOpen(false)}>
      <HeaderPageTitleWrapper onClick={handleMenuOpen}>
        {renderTitle()}
        {menu ? (
          <>
            <Spacer width="1x" />
            <Chevron direction="down" fontSize="12px" />
            {isMenuOpen ? <Menu /> : null}
          </>
        ) : null}
      </HeaderPageTitleWrapper>
    </ClickOutside>
  );
};

const HeaderPageTitleWrapper = styled(Row).attrs({ align: "center" })`
  position: relative;
  cursor: pointer;
  height: 50px;
  white-space: nowrap;
`;
